"use client";

import { useRegisterRecentlyViewed } from "@/app/lib/hooks/useRegisterRecentlyViewed";

interface RegisterRecentlyViewProps {
  performanceId: string;
}

/**
 * Cierra el mecanismo de alta de "vistos recientemente" entregado sin
 * consumidor por specs/024-vistos-recientemente: da de alta el evento de esta
 * ficha en el historial, sin renderizar nada. Leaf `'use client'` porque el
 * hook necesita `document.cookie`; la página que lo aloja permanece Server
 * Component (Constitución, Principio I).
 */
export function RegisterRecentlyView({ performanceId }: RegisterRecentlyViewProps) {
  useRegisterRecentlyViewed(performanceId);
  return null;
}
